import React from 'react';
import { Button } from '../../UIKit';
import { TFunction } from 'i18next';
import { OptionsObject, TransitionCloseHandler } from 'notistack';
import { ToastVariant } from './ToastVariant';
import { CloseIcon } from '~/Components/Icons/CloseIcon';

export const dismissableToastOptions = (
  hideDuration: number,
  toastId: string,
  variant: ToastVariant,
  t: TFunction,
  closeCallback: TransitionCloseHandler,
  closeSnackbar: (key?: number | string | undefined) => void,
) =>
  ({
    autoHideDuration: hideDuration,
    action: (key: string) => (
      <Button style={{ padding: 0, margin: 0 }} onClick={() => closeSnackbar(key)}>
        <CloseIcon style={{ color: 'white', width: '18px', height: '18px' }} />
      </Button>
    ),
    key: toastId,
    variant,
    preventDuplicate: true,
    onClose: closeCallback,
  } as OptionsObject);
